import { render, staticRenderFns } from "./StepFeatures.vue?vue&type=template&id=03bdc329&"
import script from "./StepFeatures.vue?vue&type=script&lang=js&"
export * from "./StepFeatures.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports